<p>
  element-render-hottext works!
</p>
